export default "__VITE_ASSET__tInBySWD__"